module.exports = __webpack_public_path__ + "img/logo_redondo.f7c648b8.png";